<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 px-0">
      <nav class="navbar sticky-top main-nav px-3">
        <span
          class="back-button f-18 border-0 primary-font-bold mb-4"
          aria-label="Back navigation"
        >
          <img
            (click)="goHome()"
            src="/assets/icons/back-btn.svg"
            alt="back"
            class="mr-2"
          />
          Order summary
        </span>
      </nav>
      <div class="page-content">
        <div class="card border-0 mb-4 p-16 bg-payment-confirmed">
          <div class="d-flex flex-row nav-gap align-items-center">
            <div>
              <img src="/assets/icons/payment-confirmed.svg" alt="" />
            </div>
            <div>
              <p class="primary-font-normal text-light mb-0">
                Your payment has been confirmed.
              </p>
              <p class="f-14 primary-font-normal text-light mb-0">
                Thanks for placing an order.
              </p>
            </div>
          </div>
        </div>
        <div class="px-3 py-4">
          <div class="text-center mb-2">
            <p class="text-gray-500 primary-font-normal f-14">
              Thank you for your order
            </p>
          </div>
          <div class="star-lines mb-2">
            <p class="lines mb-0">
              <img src="/assets/icons/star.svg" class="star" alt="star" />
            </p>
          </div>

          <div *ngFor="let cart of allOrders; index as i">
            <mat-accordion>
              <mat-expansion-panel
                [expanded]="i === 0"
                class="mb-2"
                *ngIf="allOrders?.length > 1"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <p class="primary-font-medium mb-0">Order {{ i + 1 }}</p>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-order-items
                  [isSuccessPage]="true"
                  [dishes]="cart"
                  [inExpansionPanel]="true"
                  (refreshCart)="handleCartRefresh($event)"
                ></app-order-items>
              </mat-expansion-panel>
            </mat-accordion>

            <div *ngIf="allOrders?.length === 1">
              <app-order-items
                [isSuccessPage]="true"
                [dishes]="cart"
                (refreshCart)="handleCartRefresh($event)"
                [inExpansionPanel]="false"
              ></app-order-items>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
